import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

import { AssetClass } from './filters/AssetClass';
import { AssetDNS } from './filters/AssetDNS';
import { AssetName } from './filters/AssetName';
import { AssetOrigins } from './filters/AssetOrigins';
import { AssetPrivate } from './filters/AssetPrivate';
import { AssetSource } from './filters/AssetSource';
import { AssetStatus } from './filters/AssetStatus';
import { AssetSurface } from './filters/AssetSurface';
import { AssetTags } from './filters/AssetTags';

/**
 * Get simple filter definitions for Asset entity
 * Returns filter names mapped to available values and operators
 *
 * @returns Array of filter names to SimpleFilterDefinition
 */
export function getAssetSimpleFilters(): SimpleFilterDefinition[] {
  return [
    AssetClass,
    AssetDNS,
    AssetName,
    AssetOrigins,
    AssetPrivate,
    AssetSource,
    AssetStatus,
    AssetSurface,
    AssetTags,
  ];
}
